"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientTypesUtility = exports.clientTypes = void 0;
const clientTypes = exports.clientTypes = {
  PUBLISHER_DAPP: "PUBLISHER_DAPP",
  MARKETPLACE_DAPP: "MARKETPLACE_DAPP",
  RFAI_DAPP: "RFAI_DAPP",
  STAKE_DAPP: "STAKE_DAPP"
};
const clientTypesUtility = exports.clientTypesUtility = {
  PUBLISHER: "PUBLISHER",
  MARKETPLACE: "MARKETPLACE",
  RFAI: "RFAI",
  STAKE: "STAKE"
};